import { FeatureFlagEnum } from "#root/config/enums/feature-flag.enum";
import { Permissions } from "#root/shared/enums/permission.enum";
import { environment } from "environments/environment";

export const hideItemNavigation = (params: {
  permissions: Permissions[];
  userPermissions: Permissions[];
  mode: "any" | "all";
  featureFlag?: FeatureFlagEnum;
  hideWhenFeatureEnabled?: FeatureFlagEnum;
}) => {
  if (params.featureFlag) {
    const featureFlag = environment.appConfig.featureFlags.find(
      (flag) => flag.key === params.featureFlag,
    );

    if (!featureFlag.enabled) {
      return true;
    }
  }

  if (params.hideWhenFeatureEnabled) {
    const featureFlag = environment.appConfig.featureFlags.find(
      (flag) => flag.key === params.hideWhenFeatureEnabled,
    );

    if (featureFlag?.enabled) {
      return true;
    }
  }

  if (params.mode === "any") {
    return !params.permissions.some((permission) =>
      params.userPermissions.includes(permission),
    );
  }

  return !params.permissions.every((permission) =>
    params.userPermissions.includes(permission),
  );
};
